import { type SingleSelectedValueFilter } from '../types'
import CoverageStartDateFilter from './CoverageStartDateFilter'

const CoverageStartBeforeDateFilter = (props: SingleSelectedValueFilter) => {
  return (
    <CoverageStartDateFilter {...props} rangeType='Coverage starts before' />
  )
}

export default CoverageStartBeforeDateFilter
